var map = {
	"./circle.png": 114,
	"./close.png": 115,
	"./default_images/venori_no_image.png": 61,
	"./diamond.png": 116,
	"./education-imgs/carat.png": 117,
	"./education-imgs/clarity-fl.png": 118,
	"./education-imgs/clarity-si1.png": 119,
	"./education-imgs/clarity-si2.png": 120,
	"./education-imgs/clarity-vs2.png": 121,
	"./education-imgs/clarity-vvs1.png": 122,
	"./education-imgs/color-colorless.png": 123,
	"./education-imgs/color-g.png": 124,
	"./education-imgs/color-h.png": 125,
	"./education-imgs/color-i.png": 126,
	"./education-imgs/color-noticeable.png": 127,
	"./education-imgs/cutting-1.png": 128,
	"./education-imgs/cutting-2.png": 129,
	"./education-imgs/cutting-3.png": 130,
	"./education-imgs/cutting-4.png": 131,
	"./education-imgs/education-img-cover-carat.png": 132,
	"./education-imgs/education-img-cover-clarity.png": 133,
	"./education-imgs/education-img-cover-color.png": 134,
	"./education-imgs/education-img-cover-cutting.png": 135,
	"./engagementRings/accented_stone.png": 136,
	"./engagementRings/bezel_set.png": 137,
	"./engagementRings/engagementRings_blurred/accented_stone.png": 138,
	"./engagementRings/engagementRings_blurred/bezel_set.png": 139,
	"./engagementRings/engagementRings_blurred/halo.png": 140,
	"./engagementRings/engagementRings_blurred/solitaire.png": 141,
	"./engagementRings/engagementRings_blurred/three_stone.png": 142,
	"./engagementRings/engagementRings_blurred/two_stone.png": 143,
	"./engagementRings/engagementRings_blurred/vintage.png": 144,
	"./engagementRings/halo.png": 145,
	"./engagementRings/solitaire.png": 146,
	"./engagementRings/three_stone.png": 147,
	"./engagementRings/two_stone.png": 148,
	"./engagementRings/vintage.png": 149,
	"./error.png": 75,
	"./fineJewelry/bracelet.png": 150,
	"./fineJewelry/earrings.png": 151,
	"./fineJewelry/fineJewelry_blurred/bracelet.png": 152,
	"./fineJewelry/fineJewelry_blurred/earrings.png": 153,
	"./fineJewelry/fineJewelry_blurred/necklace.png": 154,
	"./fineJewelry/fineJewelry_blurred/pendant.png": 155,
	"./fineJewelry/fineJewelry_blurred/ring.png": 156,
	"./fineJewelry/necklace.png": 157,
	"./fineJewelry/pendant.png": 158,
	"./fineJewelry/ring.png": 159,
	"./icons/icon-search.png": 160,
	"./icons/icon-trash.png": 161,
	"./labs/GIA.png": 162,
	"./labs/HRD.png": 163,
	"./labs/IGI.png": 164,
	"./mainPage/background_text.png": 165,
	"./mainPage/br1.png": 166,
	"./mainPage/br2_1.png": 167,
	"./mainPage/br2_2.png": 168,
	"./mainPage/br3.png": 169,
	"./mainPage/br4.png": 170,
	"./mainPage/design1.png": 171,
	"./mainPage/design2.png": 172,
	"./mainPage/diamond1.png": 173,
	"./mainPage/diamond2.png": 174,
	"./mainPage/main-landing/girl-mobile.png": 175,
	"./mainPage/main-landing/girl.png": 176,
	"./mainPage/main-landing/promocode_girl.png": 177,
	"./mainPage/pointer/active.png": 178,
	"./mainPage/pointer/default.png": 179,
	"./mainPage/pointer/hover.png": 180,
	"./mainPage/ring1.png": 181,
	"./mainPage/ring2.png": 182,
	"./mainPage/st-valentine/girl_red.png": 183,
	"./mainPage/st-valentine/heart.png": 184,
	"./shapes/asscher.png": 76,
	"./shapes/cushion.png": 77,
	"./shapes/cushion_modified.png": 78,
	"./shapes/emerald.png": 79,
	"./shapes/heart.png": 80,
	"./shapes/marquise.png": 81,
	"./shapes/oval.png": 82,
	"./shapes/pear.png": 83,
	"./shapes/princess.png": 84,
	"./shapes/radiant.png": 85,
	"./shapes/round.png": 86,
	"./shapes/shapes_blurred/asscher.png": 87,
	"./shapes/shapes_blurred/cushion.png": 88,
	"./shapes/shapes_blurred/emerald.png": 89,
	"./shapes/shapes_blurred/heart.png": 90,
	"./shapes/shapes_blurred/marquise.png": 91,
	"./shapes/shapes_blurred/oval.png": 92,
	"./shapes/shapes_blurred/pear.png": 93,
	"./shapes/shapes_blurred/princess.png": 94,
	"./shapes/shapes_blurred/radiant.png": 95,
	"./shapes/shapes_blurred/round.png": 96,
	"./svgicons/princess-regular.png": 185,
	"./venori-logotype.png": 186,
	"./weddingRings/alternative_metal_band.png": 187,
	"./weddingRings/anniversary_ring.png": 188,
	"./weddingRings/carved_ring.png": 189,
	"./weddingRings/classic_band.png": 190,
	"./weddingRings/eternity_ring.png": 191,
	"./weddingRings/mens_diamond_band.png": 192,
	"./weddingRings/stackable_ring.png": 193,
	"./weddingRings/weddingRings_blurred/alternative_metal_band.png": 194,
	"./weddingRings/weddingRings_blurred/anniversary_ring.png": 195,
	"./weddingRings/weddingRings_blurred/carved_ring.png": 196,
	"./weddingRings/weddingRings_blurred/classic_band.png": 197,
	"./weddingRings/weddingRings_blurred/eternity_ring.png": 198,
	"./weddingRings/weddingRings_blurred/mens_diamond_band.png": 199,
	"./weddingRings/weddingRings_blurred/stackable_ring.png": 200,
	"./weddingRings/weddingRings_blurred/womens_diamond_band.png": 201,
	"./weddingRings/womens_diamond_band.png": 202,
	"./wrong.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;